// import external modules
import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Logo from "../../../../assets/img/logo.png";
// import internal(own) modules
import { FoldedContentConsumer } from "../../../../utility/context/toggleContentContext";
import { getServiceFieldFromCompany } from "../../../../utility/support";

const link = {
  empresas: '/dashboard',
  entregas: '/new-order',
  '': '#'
}

function SidebarHeader({ toggleSidebarMenu }) {
  const { company } = useSelector((state) => state);
  const [ayoService, setAyoService] = useState('');

  function handleClick(e) {
    toggleSidebarMenu("close");
  }

  useEffect(() => {
    const service = getServiceFieldFromCompany(company);
    setAyoService(service);
  }, [company])

  return (
    <FoldedContentConsumer>
      {(context) => (
        <div className="sidebar-header">
          <div className="logo d-flex justify-content-center">
            <NavLink to={link[ayoService]} className="logo-text">
              <div className="logo-img">
                <img src={Logo} alt="logo" />
              </div>

              <div className="font-small-3" style={{ margin: -2 }}>
                <b>{ayoService === 'empresas' ? 'Empresas' : 'Entregas'}</b>
              </div>
            </NavLink>

            <span
              href=""
              className="nav-close d-block d-md-block d-lg-none d-xl-none"
              id="sidebarClose"
            >
              <X onClick={handleClick} size={20} />
            </span>
          </div>
        </div>
      )}
    </FoldedContentConsumer>
  );
}

export default SidebarHeader;
